export default {
  getEnrollmentTemplatesRequest (state) {
    state.enrollmentTemplates = []
    state.loading = true
  },
  getEnrollmentTemplatesSuccess (state, data) {
    state.enrollmentTemplates = data
    state.loading = false
  },
  getEnrollmentTemplatesFailure (state) {
    state.enrollmentTemplates = []
    state.loading = false
  },
  addEnrollmentTemplateRequest (state) {
    state.loading = true
  },
  addEnrollmentTemplateSuccess (state, data) {
    state.loading = false
  },
  addEnrollmentTemplateFailure (state) {
    state.loading = false
  },
  updateEnrollmentTemplateRequest (state) {
    state.loading = true
  },
  updateEnrollmentTemplateSuccess (state, data) {
    state.loading = false
  },
  updateEnrollmentTemplateFailure (state) {
    state.loading = false
  },
  deleteEnrollmentTemplateRequest (state) {
    state.loading = true
  },
  deleteEnrollmentTemplateSuccess (state, data) {
    state.loading = false
  },
  deleteEnrollmentTemplateFailure (state) {
    state.loading = false
  },

  getTemplateRequest (state) {
    state.loading = true
    state.enrollmentTemplate = {}
  },
  getTemplateSuccess (state, data) {
    state.loading = false
    state.enrollmentTemplate = data
  },
  getTemplateFailure (state) {
    state.loading = false
    state.enrollmentTemplate = {}
  }
}
